import React, { forwardRef, memo } from "react";
import { Textarea } from "@/components/ui/textarea";
import PageContentWithEditor from "../TextEditer/TextEditer";
import { cn } from "@/lib/utils";
import CustomTooltip from "@/components/ui/CustomTooltip";

const TextAreaCard = (
  {
    id,
    title,
    titleIcon = "",
    titleIconText = "",
    value,
    onChange,
    disabled = false,
    placeholder,
    borderLine = false,
    style = {},
    type = "",
    label = "",
    name,
    bgColor,
    h = "h-full",
    className = "",
    error = false,
    headingClass = "",
    required = false,
    onBlur = () =>null
  },
  ref = null
) => {
  return (
    <>
      {title && (
        <div className="flex items-center gap-1.5">
          <h3 className={cn("text-sm font-semibold text-foreground font-sans", headingClass)}>
            {title}
            {required && (
              <span className="text-error ml-0.5">*</span>
            )}
          </h3>
          {titleIcon && (
            <CustomTooltip content={titleIconText}>
              <div className="relative group">
                {typeof titleIcon === "string" ? (
                  <img
                    src={titleIcon}
                    alt="icon"
                    className="w-5 h-5"
                    // title={titleIconText}
                  />
                ) : (
                  titleIcon
                )}
              </div>
            </CustomTooltip>
          )}
        </div>
      )}

      {type === "formatter" ? (
        <>
          {disabled ? (
            <div
              ref={ref}
              id={id}
              name={name}
              placeholder={placeholder}
              style={style}
              className={cn(
                `w-full max-h-[400px] overflow-auto h-full rounded-xl p-4 text-sm leading-relaxed bg-white dark:bg-black text-gray-800 dark:text-white ${h} ${
                  borderLine ? "border border-card-border" : ""
                } ${className}`
              )}
              dangerouslySetInnerHTML={{ __html: value }}
            />
          ) : (
            <PageContentWithEditor
              id={id}
              disabled={disabled}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              error={error}
            />
          )}
        </>
      ) : (
        <Textarea
          ref={ref}
          id={id}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          style={style}
          className={cn(
            `overflow-auto ${h} resize-none rounded-2xl p-4 text-sm leading-relaxed text-foreground 
            bg-background/30 
            focus-visible:ring-0 focus:ring-0 focus:outline-none
            ${
              borderLine
                ? `border ${error ? "border-red-500" : "border-border"}`
                : ""
            } ${bgColor ? bgColor : "bg-background/30"} ${className}`
          )}
        />
      )}
    </>
  );
};

export default memo(forwardRef(TextAreaCard));
